import MineDamageLogic from "../../../logic/MineDamageLogic";
import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import BigNumValue from "../../value/BigNumValue";
import ClassicUpgrade from "../classic/ClassicUpgrade";
import UpgradeCostCalculator from "../classic/UpgradeCostCalculator";
import { UpgradeCostUnit } from "../UpgradeCostUnit";

export default class PickUpgrade extends ClassicUpgrade {
    /**
     * @param {string} id
     * @param {string} title
     * @param {string} iconFileName
     * @param {UpgradeCostCalculator} upgradeCostCalculator 
     * @param {Totals} totals
     * @param {MineDamageLogic} mineDamageLogic
     * @param {BigNumValue} upgradeBonusValue External value holder for upgrade bonus.
     * @param {BigNum} valuePerUpgrade
     * @param {PickUpgrade} dependentUpgrade
     * @param {number} requiredPurchaseCount
     * @param {number} maxCount
     * @param {boolean} additiveUpgrade False for multiplicative
     */
    constructor(id, title, iconFileName, upgradeCostCalculator, totals, mineDamageLogic, upgradeBonusValue, 
            valuePerUpgrade, dependentUpgrade, requiredPurchaseCount, maxCount, additiveUpgrade) {
        super(id, title, iconFileName, upgradeCostCalculator, maxCount);

        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;

        /**
         * @constant
         * @type {MineDamageLogic}
         */
        this.mineDamageLogic = mineDamageLogic;

        /**
         * @constant
         * @type {BigNumValue}
         */
        this.upgradeBonusValue = upgradeBonusValue;

        /**
         * @constant
         * @type {BigNum}
         */
        this.valuePerUpgrade = valuePerUpgrade;

        /**
         * @constant
         * @type {PickUpgrade}
         */
        this.dependentUpgrade = dependentUpgrade;

        /**
         * @constant
         * @type {number}
         */
        this.requiredPurchaseCount = requiredPurchaseCount;

        /**
         * @constant
         * @type {BigNum}
         */
        this.workingValue = new BigNum(0);

        /**
         * @constant
         * @type {boolean}
         */
        this.additiveUpgrade = additiveUpgrade;

        // This must be invoked here
        this.initializeCosts();
    }

    /**
     * @override
     * @returns {boolean}
     */
    isVisible() {
        if (this.purchasedCount >= this.maxCount) {
            return false;
        }

        if (this.dependentUpgrade && this.dependentUpgrade.purchasedCount < this.requiredPurchaseCount) {
            return false;
        }

        return true;
    }

    //////////////////////////////////////
    // Upgrade overrides
    //////////////////////////////////////

    /**
     * @override
     * @returns {string} See UpgradeCostUnit
     */
    getCostUnit() {
        return UpgradeCostUnit.ORE;
    }

    //////////////////////////////////////
    // ClassicUpgrade overrides
    //////////////////////////////////////

    /**
     * @override
     * @returns {BigNum}
     */
    getMoney() {
        return this.totals.ore;
    }

    /**
     * @override
     * @param {BigNum} money 
     */
    decrementMoney(money) {
        this.totals.decrementOre(money);
    }

    /**
     * Invoked by the base class to let the sub-class know that a purchase has been made.
     * @override
     * @param {number} currentCount This is the before value.
     * @param {number} purchaseCount 
     */
    onUpgradePurchased(currentCount, purchaseCount) {

        this.workingValue.copy(this.valuePerUpgrade);

        if (purchaseCount > 1) {
            this.workingValue.mulNumber(purchaseCount);
        }

        this.upgradeBonusValue.incrementValue(this.workingValue);

        this.mineDamageLogic.calculateTotalMineDamagePerTurn();
    }

}